import { IconButton, Modal } from "@carbon6/c6-frontend-design";
import styles from "./ConfirmModal.module.css";

type HideDatasetModalProps = {
  datasetName: string;
  errorMessage: string | null;
  submitting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

/**
 * 숨김 확인.
 *
 * 숨김은 **조직 공용**이라 누른 사람뿐 아니라 다른 Member 목록에서도 사라진다 — 되돌릴 수
 * 있어도 한 번 확인한다. 반대로 `다시 보이기` 는 확인 없이 즉시 실행한다(잃는 것이 없다).
 */
export function HideDatasetModal({
  datasetName,
  errorMessage,
  onCancel,
  onConfirm,
  submitting,
}: HideDatasetModalProps) {
  return (
    <Modal
      open
      closeOnBackdropClick={!submitting}
      closeOnEscape={!submitting}
      size="sm"
      onClose={onCancel}
    >
      <Modal.Header>
        <Modal.Header.Start>
          <Modal.Header.Title>Dataset 숨기기</Modal.Header.Title>
        </Modal.Header.Start>
        <Modal.Header.End>
          <Modal.Header.Close disabled={submitting} label="닫기" />
        </Modal.Header.End>
      </Modal.Header>
      <Modal.Body>
        <p className={styles.eyebrow}>{datasetName}</p>
        <p className={styles.caption}>
          이 Dataset 을 조직 목록에서 숨깁니다. 삭제가 아니며 언제든 다시 보이게 할 수 있습니다.
        </p>
        {errorMessage === null ? null : (
          <p className={styles.error} role="alert">
            {errorMessage}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.actions}>
          <IconButton
            disabled={submitting}
            text="취소"
            tone="neutral"
            type="button"
            variant="surface"
            onClick={onCancel}
          />
          <IconButton
            disabled={submitting}
            text={submitting ? "숨기는 중" : "숨기기"}
            tone="warning"
            type="button"
            variant="solid"
            onClick={onConfirm}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
}
